import Button, { ButtonModeE } from "../../components/Button/Button";
import UnsavedChangesWarningBody from "./UnsavedChangesWarningBody";
import UnsavedChangesWarningFooter from "./UnsavedChangesWarningFooter";

import styles from './unsavedChangesWarning.module.scss';

export default ({
    header: <></>,
    body: <UnsavedChangesWarningBody/>,
    footer: <UnsavedChangesWarningFooter/>,
    className: styles.popupWrapper,
});